/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'marketing' */ './home'),
    },
    {
      path: '/how-it-works',
      load: () => import(/* webpackChunkName: 'marketing' */ './howItWorks'),
    },
    {
      path: '/pricing',
      load: () => import(/* webpackChunkName: 'marketing' */ './pricing'),
    },
    {
      path: '/legal',
      load: () => import(/* webpackChunkName: 'marketing' */ './privacy'),
    },
    {
      path: '/0538b3c4-6c90-422f-9893-63ab9682e42c',
      load: () => import(/* webpackChunkName: 'webinar' */ './webinar'),
    },
    {
      path: '/social-media-checklist',
      load: () => import(/* webpackChunkName: 'socialLead' */ './socialLead'),
    },
    {
      path: '/social-media-program',
      load: () => import(/* webpackChunkName: 'socialLanding' */ './socialLanding'),
    },
    {
      path: '/video-course-part-one',
      load: () => import(/* webpackChunkName: 'videoCourseOne' */ './videoCourseOne'),
    },
    {
      path: '/video-course-part-two',
      load: () => import(/* webpackChunkName: 'videoCourseTwo' */ './videoCourseTwo'),
    },
    {
      path: '/video-course-part-three',
      load: () => import(/* webpackChunkName: 'videoCourseThree' */ './videoCourseThree'),
    },
    {
      path: '/browse',
      children: [
        {
          path: '',
          load: () => import(/* webpackChunkName: 'browse' */ './browse'),
        },
        {
          path: '/scene/:sceneSlug',
          load: () => import(/* webpackChunkName: 'browse' */ './browse'),
        },
        {
          path: '/scene/:sceneSlug/:clipSlug',
          load: () => import(/* webpackChunkName: 'browse' */ './browse'),
        },
        {
          path: '(.*)',
          load: () => import(/* webpackChunkName: 'browse' */ './browse'),
        },
      ],
    },
    {
      path: '/dashboard',
      children: [
        {
          path: '',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
        {
          path: '/profile',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
        {
          path: '/upgrade',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
        {
          path: '/licenses',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
        {
          path: '/subscription',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
        {
          path: '(.*)',
          load: () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
        },
      ],
    },

    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      action: () => ({ redirect: '/' }),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title =
      route.title || 'Storytape - One subscription. Unlimited 4K stock footage video clips.';
    route.description =
      route.description ||
      'Storytape is an unlimited stock footage platform. Each month we add more than 500+ new 4K video clips. Browse the full cinematic library for free.';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js